import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const TOAST_OPTIONS = {
    position: 'top-right',
    autoClose: 1000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
};

export const alertOnSuccess = (message) => toast.success(message, TOAST_OPTIONS);
export const alertOnError = (message) => toast.error(message, TOAST_OPTIONS);
export const alertOnValidation = (message) => toast.warn(message, TOAST_OPTIONS);

const AppAlerts = () => {
    const delete_state = useSelector((state) => state.common.delete);
    const form_state = useSelector((state) => state.common.form);
    const code_error = useSelector((state) => state.code_error);

    // For Create and Update Form
    useEffect(() => {
        if (form_state.success === true && form_state.payload?.success === true) {
            alertOnSuccess(form_state.payload.message);
        }
        if (form_state.errors?.validation_errors && form_state.errors.success === false) {
            alertOnValidation(form_state.errors.message);
        }
    }, [form_state]);

    // For Delete
    useEffect(() => {
        if (delete_state.success === true && delete_state.payload) {
            alertOnSuccess(delete_state.payload.message);
        }
    }, [delete_state]);

    // For Code Error
    useEffect(() => {
        if (code_error.message !== null) {
            alertOnError(code_error.message);
        }
    }, [code_error]);

    return <ToastContainer />;
};

export default AppAlerts;
